import React, { FunctionComponent, useEffect, useState } from "react";
import { Container } from "src/components/atoms/container/container";
import { ListNews } from "src/components/organisms/lists/listNews/listNews";
import { PageHeader } from "src/components/molecules/pageHeader/pageHeader";
import { ListItemSkeleton } from "src/components/atoms/skeleton/listItemSkeleton";
import { Page } from "src/layouts/page";
import { NewsEntreprise, OfferRH, OfferSwissRH } from "src/types/ApiItems";
import { AppNewsType } from "src/types/dataTypes";
import { ErrorScreen } from "src/components/molecules/errorScreen/errorScreen";
import { ErrorCodes } from "src/helpers/enum";
import { SwissOffers } from "src/components/organisms/lists/listSwissOffers/listSwissOffers";
import { Text } from "src/components/atoms/text/text";

type Config = {
  REACT_APP_ANNONCES_SWITZERLAND: number;
  REACT_APP_ANNONCES_WORLD: number;
  REACT_APP_ANNONCES_SUCCESS_FACTOR_LINK: string;
}

async function getParameters(): Promise<Config> {
  try {
    const response = await fetch('/config.json');

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching parameters:', error);
    throw error;
  }
}

export type NewsByCategoryPageProps = {
  title: string;
  back: any;
  dontMiss?: boolean;
  type: AppNewsType;
  get(): Promise<NewsEntreprise[] | OfferRH[]>;
  getSwissOffers: () => Promise<OfferSwissRH[]>;
};

export const NewsByCategoryPage: FunctionComponent<NewsByCategoryPageProps> = ({
  back,
  title,
  type,
  dontMiss,
  get,
  getSwissOffers,
}) => {
  const [config, setConfig] = useState<Config>({
    REACT_APP_ANNONCES_SWITZERLAND: 7,
    REACT_APP_ANNONCES_WORLD: 3,
    REACT_APP_ANNONCES_SUCCESS_FACTOR_LINK: 'https://hcm55.sapsf.eu/sf/careers/jobsearch?bplte_company=patekphili',
  });
  const [news, setNews] = useState<NewsEntreprise[] | null>(null);
  //const [showAllNews, setShowAllNews] = useState<boolean>(false);
  const [swissNews, setSwissNews] = useState<OfferSwissRH[] | null>(null);
  //const [showAllSwissNews, setShowAllSwissNews] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setError(false);

    Promise.all([getParameters(), get(), getSwissOffers()]).then(([config, internationalOffers, swissOffers]) => {
      setConfig(config);
      setNews(internationalOffers);
      setSwissNews(swissOffers);
    }).catch(e => {
      setError(true);
    });
  }, []); // eslint-disable-line

  return (
    <Page>
      <PageHeader back={back} title={title} />
      <Container small left>
        {error && <ErrorScreen code={ErrorCodes.NEWS_GET_FAIL} info="Erreur lors de la récupération des données" />}
        <Text type="h2" className='news-by-category--title'>En Suisse</Text>
        {!swissNews && !error && <ListItemSkeleton numberItem={config.REACT_APP_ANNONCES_SWITZERLAND} />}
        {swissNews && <SwissOffers offers={swissNews.slice(0, config.REACT_APP_ANNONCES_SWITZERLAND)} type={type} badgeBorderLess />}
        <strong className="news-by-category--mt news-by-category--display-block news-by-category--pointer-cursor text--orange"><small><a href={config.REACT_APP_ANNONCES_SUCCESS_FACTOR_LINK} target="_blank">Voir plus d'offres d'emploi</a></small></strong>
        {/*
          showAllSwissNews
          ? <strong className="news-by-category--mt news-by-category--display-block news-by-category--pointer-cursor text--orange" onClick={() => setShowAllSwissNews(!showAllSwissNews)}><small>Voir moins</small></strong>
          :
            swissNews && swissNews.length > numberAnnoncesSwitzerland
            ? <strong className="news-by-category--mt news-by-category--display-block news-by-category--pointer-cursor text--orange" onClick={() => setShowAllSwissNews(!showAllSwissNews)}><small>Voir plus d'offres d'emploi</small></strong>
            : undefined
        */}
        <Text type="h2" className='news-by-category--mt news-by-category--title'>A l'international</Text>
        {!news && !error && <ListItemSkeleton numberItem={config.REACT_APP_ANNONCES_WORLD} />}
        {news && <ListNews news={news.slice(0, config.REACT_APP_ANNONCES_WORLD)} type={type} badgeBorderLess />}
        {/*
          showAllNews
          ? <strong className="news-by-category--mt news-by-category--display-block news-by-category--pointer-cursor text--orange" onClick={() => setShowAllNews(!showAllNews)}><small>Voir moins</small></strong>
          :
            news && news.length > numberAnnoncesWorld
            ? <strong className="news-by-category--mt news-by-category--display-block news-by-category--pointer-cursor text--orange" onClick={() => setShowAllNews(!showAllNews)}><small>Voir plus d'offres d'emploi</small></strong>
            : undefined
        */}
      </Container>
    </Page>
  );
};
NewsByCategoryPage.defaultProps = {
  type: "company",
};
